import { apis } from '../apiBase/apiBase';
export const projectApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: (params) => {
                return {
                    url: `projects`,
                    params: params,
                };
            },
        }),
        getProject: builder.query({
            query: (param) => ({
                url: `projects/${param.projectId}`,
                method: 'GET',
            }),
        }),
        deleteProject: builder.mutation({
            query: (params) => ({
                url: `projects/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        insertProject: builder.mutation({
            query: (params) => ({
                url: `projects/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateProject: builder.mutation({
            query: (params) => ({
                url: `projects/update`,
                method: `POST`,
                body: params,
            }),
        }),
        insertEvent: builder.mutation({
            query: (params) => ({
                url: `projects/events/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectTasks: builder.query({
            query: (params) => ({
                url: `projects/${params.projectId}/tasks`,
                params: params,
            }),
        }),
        getEvent: builder.query({
            query: (param) => ({
                url: `events/${param.eventId}`,
                method: 'GET',
            }),
        }),
        updateEvent: builder.mutation({
            query: (params) => ({
                url: `projects/events/update`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteEvent: builder.mutation({
            query: (params) => ({
                url: `projects/events/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectProgress: builder.query({
            query: (params) => {
                return {
                    url: `projects/${params.projectId}/progress`,
                };
            },
        }),
        getEventTasks: builder.query({
            query: (params) => {
                return {
                    url: `events/${params.eventId}/tasks`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getEventFiles: builder.query({
            query: (params) => {
                return {
                    url: `events/${params.eventId}/files`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getProjectMembers: builder.query({
            query: (params) => {
                return {
                    url: `project-members`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        insertProjectMembers: builder.mutation({
            query: (params) => ({
                url: `project-members/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateProjectMember: builder.mutation({
            query: (params) => ({
                url: `project-members/update`,
                method: 'POST',
                body: params,
            }),
        }),
        deleteProjectMembers: builder.mutation({
            query: (params) => ({
                url: `project-members/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectMember: builder.query({
            query: (params) => {
                return {
                    url: `project-members/${params.userId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getNonProjectMembers: builder.query({
            query: (params) => {
                return {
                    url: `non-project-members/${params.projectId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getEventKind: builder.query({
            query: (params) => {
                return {
                    url: `event-kinds/${params.eventKindId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        updateEventKind: builder.mutation({
            query: (params) => ({
                url: `event-kinds/update`,
                method: `POST`,
                body: params,
            }),
        }),
        getEventKinds: builder.query({
            query: (params) => {
                return {
                    url: `event-kinds`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        insertEventKind: builder.mutation({
            query: (params) => ({
                url: `event-kinds/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteEventKind: builder.mutation({
            query: (params) => ({
                url: `event-kinds/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        reorderEventCategory: builder.mutation({
            query: (params) => ({
                url: `event-categories/reorder`,
                method: `POST`,
                body: params,
            }),
        }),
        getEventCategories: builder.query({
            query: (params) => {
                return {
                    url: `event-categories`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        deleteEventCategory: builder.mutation({
            query: (params) => ({
                url: `event-categories/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        insertEventCategory: builder.mutation({
            query: (params) => ({
                url: `event-categories/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateEventCategory: builder.mutation({
            query: (params) => ({
                url: `event-categories/update`,
                method: `POST`,
                body: params,
            }),
        }),
        reorderEventKind: builder.mutation({
            query: (params) => ({
                url: `event-kinds/reorder`,
                method: `POST`,
                body: params,
            }),
        }),
        getEventCategory: builder.query({
            query: (param) => ({
                url: `event-categories/${param.eventCategoryId}`,
                method: 'GET',
            }),
        }),
        getProjectFiles: builder.query({
            query: (params) => ({
                url: `projects/${params.projectId}/files`,
                method: 'GET',
                params: params,
            }),
        }),
        deleteProjectGroup: builder.mutation({
            query: (params) => ({
                url: `project-groups/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectGroup: builder.query({
            query: (params) => {
                return {
                    url: `project-groups/${params.projectGroupId}`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getProjectGroups: builder.query({
            query: (params) => {
                return {
                    url: `project-groups`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        insertProjectGroup: builder.mutation({
            query: (params) => ({
                url: `project-groups/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateProjectGroup: builder.mutation({
            query: (params) => ({
                url: `project-groups/update`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteEventRecording: builder.mutation({
            query: (params) => ({
                url: `event-recordings/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getEventAttendees: builder.query({
            query: (params) => {
                return {
                    url: `events/${params.eventId}/attendees`,
                    method: 'GET',
                };
            },
        }),
        insertEventAttendees: builder.mutation({
            query: (params) => ({
                url: 'event-attendees/insert',
                method: 'POST',
                body: params,
            }),
        }),
        updateEventAttendee: builder.mutation({
            query: (params) => ({
                url: 'event-attendees/update',
                method: 'POST',
                body: params,
            }),
        }),
        deleteEventAttendees: builder.mutation({
            query: (params) => ({
                url: `event-attendees/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectSettingMembers: builder.query({
            query: (params) => ({
                url: `project-setting-members`,
                method: 'GET',
                params: params,
            }),
        }),
        getProjectMemberPending: builder.query({
            query: (params) => {
                return {
                    url: `project-member-pendings/${params.invitationToken}`,
                    method: 'GET',
                };
            },
        }),
        joinProject: builder.mutation({
            query: (params) => ({
                url: `projects/join`,
                method: `POST`,
                body: params,
            }),
        }),
        newUserJoinProject: builder.mutation({
            query: (params) => ({
                url: 'project-member-pendings/join',
                method: 'POST',
                body: params,
            }),
        }),
        approveProjectMemberPending: builder.mutation({
            query: (params) => ({
                url: `/project-member-pendings/approve`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteProjectMemberPending: builder.mutation({
            query: (params) => ({
                url: `/project-member-pendings/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        bulkApproveProjectMemberPending: builder.mutation({
            query: (params) => ({
                url: `/project-member-pendings/bulk-approve`,
                method: `POST`,
                body: params,
            }),
        }),
        bulkDeleteProjectMemberPending: builder.mutation({
            query: (params) => ({
                url: `/project-member-pendings/bulk-delete`,
                method: `POST`,
                body: params,
            }),
        }),
        insertProjectMemberPendings: builder.mutation({
            query: (params) => ({
                url: '/project-member-pendings/insert',
                method: 'POST',
                body: params,
            }),
        }),
        GetMyProjectMemberPendingByProject: builder.query({
            query: (params) => {
                return {
                    url: `project-member-pendings/my-pending`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        GetEventRecordingUrl: builder.query({
            query: (params) => {
                return {
                    url: `event-recordings/signed-url`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        GetEventRecordingsAudioUrl: builder.query({
            query: (params) => {
                return {
                    url: `event-recordings/audio-signed-url`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        bulkCancelInvitation: builder.mutation({
            query: (params) => ({
                url: '/project-member-pendings/bulk-cancel-invitation',
                method: 'POST',
                body: params,
            }),
        }),
        bulkRejectRequest: builder.mutation({
            query: (params) => ({
                url: '/project-member-pendings/bulk-reject-request',
                method: 'POST',
                body: params,
            }),
        }),
        getProjectTags: builder.query({
            query: (params) => ({
                url: 'projects/tags',
                method: 'GET',
                params: params,
            }),
        }),
        verifyProjectMembersPending: builder.mutation({
            query: (params) => {
                return {
                    url: 'project-member-pendings/insert/verify',
                    method: 'POST',
                    body: params,
                };
            },
        }),
        leaveProject: builder.mutation({
            query: (params) => ({
                url: `projects/leave`,
                method: `POST`,
                body: params,
            }),
        }),
        insertProjectForDirectChannel: builder.mutation({
            query: (params) => ({
                url: `projects/direct-channels/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectForDirectChannel: builder.query({
            query: (params) => ({
                url: `projects/direct-channels/${params.projectId}`,
                method: 'GET',
            }),
        }),
        insertProjectMemberCost: builder.mutation({
            query: (params) => ({
                url: `project-members/costs/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        updateProjectMemberCost: builder.mutation({
            query: (params) => ({
                url: `project-members/costs/update`,
                method: `POST`,
                body: params,
            }),
        }),
        deleteProjectMemberCost: builder.mutation({
            query: (params) => ({
                url: `project-members/costs/delete`,
                method: `POST`,
                body: params,
            }),
        }),
        getProjectMemberCost: builder.query({
            query: (params) => {
                return {
                    url: `project-member-costs/${params.projectMemberCostId}`,
                    method: 'GET',
                };
            },
        }),
        getEvmData: builder.query({
            query: (params) => {
                return {
                    url: `projects/${params.projectId}/evm`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getMyParticipatedProjects: builder.query({
            query: (params) => {
                return {
                    url: `my-participated-projects`,
                    method: 'GET',
                };
            },
        }),
        getMeetingMinutes: builder.query({
            query: (params) => {
                return {
                    url: `events/${params.eventId}/meeting-minutes`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        updateMeetingMinutes: builder.mutation({
            query: (params) => ({
                url: `events/meeting-minutes/update`,
                method: `POST`,
                body: params,
            }),
        }),
        canJoinWebMeeting: builder.query({
            query: (param) => ({
                url: `events/${param.eventId}/can-join-meeting`,
                method: 'GET',
            }),
        }),
        getGroupSchedule: builder.query({
            query: (params) => {
                return {
                    url: `events/group-schedule`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getProjectEventsForPagination: builder.query({
            query: (params) => {
                return {
                    url: `projects/${params.projectId}/events-pagination`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getMyRoleInEvent: builder.query({
            query: (param) => ({
                url: `events/${param.eventId}/my-role`,
                method: 'GET',
            }),
        }),
        updateEventDuration: builder.mutation({
            query: (params) => ({
                url: 'events/update-duration',
                method: `POST`,
                body: params,
            }),
        }),
        insertEventFile: builder.mutation({
            query: (params) => ({
                url: `events/files/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        insertEventFiles: builder.mutation({
            query: (params) => ({
                url: `events/files/bulk-insert`,
                method: `POST`,
                body: params,
            }),
        }),
        getSubFoldersAndFiles: builder.query({
            query: (params) => ({
                url: `projects/${params.projectId}/subfolders-and-files`,
                method: 'GET',
                params,
            }),
        }),
        getMySchedule: builder.query({
            query: (params) => {
                return {
                    url: `events/my-schedule`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        checkReferenceProjectGroup: builder.query({
            query: (params) => {
                return {
                    url: `project-groups/${params.projectGroupId}/check-reference`,
                    method: 'GET',
                    params: params,
                };
            },
        }),
        getOrInsertProjectForAiAssistantChannel: builder.mutation({
            query: (params) => ({
                url: `projects/ai-assistant-channels/get-or-insert`,
                method: `POST`,
            }),
        }),
        insertProjectForGroupChat: builder.mutation({
            query: (params) => ({
                url: `projects/group-chat/insert`,
                method: `POST`,
                body: params,
            }),
        }),
        // グループチャット用のプロジェクト更新API
        updateProjectForGroupChat: builder.mutation({
            query: (params) => ({
                url: `projects/group-chat/update`,
                method: `POST`,
                body: params,
            }),
        }),
        // グループチャット用のプロジェクト削除API
        deleteProjectForGroupChat: builder.mutation({
            query: (params) => ({
                url: `projects/group-chat/delete`,
                method: `POST`,
                body: params,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetProjectSettingMembersQuery, useLazyGetProjectSettingMembersQuery, useGetProjectsQuery, useLazyGetProjectsQuery, useGetProjectQuery, useLazyGetProjectQuery, useGetProjectTasksQuery, useLazyGetProjectTasksQuery, useInsertProjectMutation, useDeleteProjectMutation, useInsertEventMutation, useGetEventQuery, useLazyGetEventQuery, useUpdateEventMutation, useUpdateProjectMutation, useDeleteEventMutation, useGetProjectProgressQuery, useLazyGetProjectProgressQuery, useGetEventTasksQuery, useLazyGetEventTasksQuery, useGetEventFilesQuery, useLazyGetEventFilesQuery, useDeleteProjectMembersMutation, useUpdateProjectMemberMutation, useInsertProjectMembersMutation, useGetProjectMembersQuery, useLazyGetProjectMembersQuery, useGetProjectMemberQuery, useLazyGetProjectMemberQuery, useGetNonProjectMembersQuery, useLazyGetNonProjectMembersQuery, useGetEventKindQuery, useLazyGetEventKindQuery, useUpdateEventKindMutation, useGetEventKindsQuery, useLazyGetEventKindsQuery, useInsertEventKindMutation, useDeleteEventKindMutation, useReorderEventKindMutation, useReorderEventCategoryMutation, useGetEventCategoriesQuery, useLazyGetEventCategoriesQuery, useDeleteEventCategoryMutation, useInsertEventCategoryMutation, useUpdateEventCategoryMutation, useGetEventCategoryQuery, useLazyGetEventCategoryQuery, useGetProjectFilesQuery, useLazyGetProjectFilesQuery, useDeleteProjectGroupMutation, useGetProjectGroupQuery, useLazyGetProjectGroupQuery, useGetProjectGroupsQuery, useLazyGetProjectGroupsQuery, useInsertProjectGroupMutation, useUpdateProjectGroupMutation, useDeleteEventRecordingMutation, useGetEventAttendeesQuery, useLazyGetEventAttendeesQuery, useInsertEventAttendeesMutation, useUpdateEventAttendeeMutation, useDeleteEventAttendeesMutation, useGetProjectMemberPendingQuery, useJoinProjectMutation, useNewUserJoinProjectMutation, useApproveProjectMemberPendingMutation, useDeleteProjectMemberPendingMutation, useBulkApproveProjectMemberPendingMutation, useBulkDeleteProjectMemberPendingMutation, useInsertProjectMemberPendingsMutation, useGetMyProjectMemberPendingByProjectQuery, useLazyGetEventRecordingUrlQuery, useGetEventRecordingUrlQuery, useGetEventRecordingsAudioUrlQuery, useBulkCancelInvitationMutation, useBulkRejectRequestMutation, useGetProjectTagsQuery, useLazyGetProjectTagsQuery, useVerifyProjectMembersPendingMutation, useLeaveProjectMutation, useInsertProjectForDirectChannelMutation, useGetProjectForDirectChannelQuery, useLazyGetProjectForDirectChannelQuery, useInsertProjectMemberCostMutation, useUpdateProjectMemberCostMutation, useDeleteProjectMemberCostMutation, useLazyGetProjectMemberCostQuery, useGetProjectMemberCostQuery, useGetEvmDataQuery, useLazyGetEvmDataQuery, useGetMyParticipatedProjectsQuery, useLazyGetMyParticipatedProjectsQuery, useGetMeetingMinutesQuery, useLazyGetMeetingMinutesQuery, useUpdateMeetingMinutesMutation, useCanJoinWebMeetingQuery, useLazyCanJoinWebMeetingQuery, useGetGroupScheduleQuery, useLazyGetGroupScheduleQuery, useGetProjectEventsForPaginationQuery, useLazyGetProjectEventsForPaginationQuery, useGetMyRoleInEventQuery, useLazyGetMyRoleInEventQuery, useUpdateEventDurationMutation, useInsertEventFileMutation, useInsertEventFilesMutation, useGetSubFoldersAndFilesQuery, useLazyGetSubFoldersAndFilesQuery, useGetMyScheduleQuery, useLazyGetMyScheduleQuery, useCheckReferenceProjectGroupQuery, useLazyCheckReferenceProjectGroupQuery, useGetOrInsertProjectForAiAssistantChannelMutation, useInsertProjectForGroupChatMutation, useUpdateProjectForGroupChatMutation, useDeleteProjectForGroupChatMutation, } = projectApis;
